import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import { Outlet, useMatch } from 'react-router-dom';
import { drawerWidth, footerHeight, headerHeight } from '../../config';
import { LayoutContext } from '../../contexts';
import { useDisclosure } from '../../hooks/useDisclosure';
import ErrorBoundary from '../ErrorBoundary';
import { NetworkDisconnectionModal } from '../NetworkDisconnectionModal/NetworkDisconnectionModal';
import DashboardFooter from './DashboardFooter';
import DashboardNavbar from './DashboardNavbar';

const useLayoutStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  contentRoot: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 1,
    display: 'flex',
    justifyContent: 'center',
    paddingTop: (props) => props.headerHeight,
    minHeight: (props) => `calc(100%-${props.headerHeight})`,
  },
  footer: {
    flexGrow: 0,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
  },
  footerShift: {
    flexGrow: 0,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: (props) => props.drawerWidth,
  },
}));

const DashboardLayout = () => {
  const sidebar = useDisclosure({
    defaultIsOpen: false,
  });
  const classes = useLayoutStyles({
    headerHeight,
    footerHeight,
    drawerWidth,
  });

  // This is used to align the footer, taking into account the applications step sidebar
  const matchNoSlash = useMatch({
    path: '/dashboard/applications/:loanId',
    end: true,
  });
  const matchWithSlash = useMatch({
    path: '/dashboard/applications/:loanId/',
    end: true,
  });
  const isApplicationsStep = Boolean(matchNoSlash || matchWithSlash);

  return (
    <ErrorBoundary>
      <LayoutContext.Provider value={{ sidebar }}>
        <Box className={classes.root}>
          <DashboardNavbar />
          <Box className={classes.contentRoot} component="main">
            <Outlet />
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
              marginLeft: isApplicationsStep ? '24rem' : 'inherit',
            }}
          >
            <DashboardFooter
              className={!sidebar.isOpen ? classes.footer : classes.footerShift}
            />
          </Box>
        </Box>
        <NetworkDisconnectionModal />
      </LayoutContext.Provider>
    </ErrorBoundary>
  );
};

export default DashboardLayout;
